export default "__VITE_ASSET__3hBfbgP6__"